import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
// import {EditCommentDialogComponent} from '../../shared/alerts/edit-comment-dialog/edit-comment-dialog.component';
// import {EditBannerDialogComponent} from '../../shared/alerts/edit-banner-dialog/edit-banner-dialog.component';
// import {CreateCommentDialogComponent} from '../../shared/alerts/create-comment-dialog/create-comment-dialog.component';
import {CreateBannerDialogComponent} from '../../shared/alerts/create-banner-dialog/create-banner-dialog.component';
import {EditTitleDialogComponent} from '../../shared/alerts/edit-title-dialog/edit-title-dialog.component';
// import {CreateProductServiceDialogComponent} from '../../shared/alerts/create-product-service-dialog/create-product-service-dialog.component';
// import {CreateUrlCardDialogComponent} from '../../shared/alerts/create-url-card-dialog/create-url-card-dialog.component';
// import {CreateVsCardDialogComponent} from '../../shared/alerts/create-vs-card-dialog/create-vs-card-dialog.component';
// import {EditVsCardDialogComponent} from '../../shared/alerts/edit-vs-card-dialog/edit-vs-card-dialog.component';
// import {EditUrlCardDialogComponent} from '../../shared/alerts/edit-url-card-dialog/edit-url-card-dialog.component';
// import {EditProductServiceDialogComponent} from '../../shared/alerts/edit-product-service-dialog/edit-product-service-dialog.component';
// import {EditNavlinkComponent} from '../../shared/alerts/edit-navlink/edit-navlink.component';
// import {EditBlogComponent} from '../../shared/edit-blog/edit-blog.component';
import {CreateBlogComponent} from '../../shared/alerts/blog/create-blog/create-blog.component';


@Injectable({
  providedIn: 'root'
})

export class HandleAlertsProvider {

  constructor(
    private dialog: MatDialog,
  ) {
  }

  // getEditVsCardsDialog(id: number, title: string, subTitle: string, img: string, img64: string,
  //                      codeImg: number, order: number, activeButton: number): any {
  //   return this.dialog.open(EditVsCardDialogComponent, {
  //     data: {id, title, subTitle, img, img64, codeImg, order, activeButton}
  //   });
  // }
  //
  // getEditUrlCardsDialog(id: number, title: string, subTitle: string, img: string, img64: string, codeImg: number,
  //                       order: number, activeButton: number, url?: string): any {
  //   return this.dialog.open(EditUrlCardDialogComponent, {
  //     data: {id, title, subTitle, img, img64, codeImg, order, activeButton, url}
  //   });
  // }
  //
  // getEditCommentDialog(id: number, codeImg: number, title: string, subTitle: string, comment: string, img: string, img64: string): any {
  //   return this.dialog.open(EditCommentDialogComponent, {
  //     data: {id, codeImg, title, subTitle, comment, img, img64}
  //   });
  // }
  //
  // getEditBannerDialog(id: number, typeId: number, order: number, img: string, img64: string,
  //                     title: string, subTitle: string, subTitle2: string, nameButton1: string, urlButton1: string): any {
  //   return this.dialog.open(EditBannerDialogComponent, {
  //     data: {id, typeId, order, img, img64, title, subTitle, subTitle2, nameButton1, urlButton1}
  //   });
  // }
  //
  // getCreateVsCard(title: string, subTitle: string, img: string, img64: string, codeImg: number, order: number, activeButton: number): any {
  //   return this.dialog.open(CreateVsCardDialogComponent, {
  //     data: {title, subTitle, img, img64, codeImg, order, activeButton}
  //   });
  // }
  //
  // getCreateUrlCard(title: string, subTitle: string, img: string, img64: string, codeImg: number, order: number,
  //                  activeButton: number, url?: string): any {
  //   return this.dialog.open(CreateUrlCardDialogComponent, {
  //     data: {title, subTitle, img, img64, codeImg, order, activeButton, url}
  //   });
  // }
  //
  // getCreateComment(title: string, subTitle: string, comment: string, img: string, img64: string, codeImg: number, typeId: number): any {
  //   return this.dialog.open(CreateCommentDialogComponent, {
  //     data: {title, subTitle, comment, img, img64, codeImg, typeId}
  //   });
  // }

  getCreateBanner(typeId: number, order: number, img: string, img64: string, title: string, subTitle: string, subTitle2: string,
                  nameButton1: string, urlButton1: string): any {
    return this.dialog.open(CreateBannerDialogComponent, {
      data: {img, img64, title, subTitle, subTitle2, nameButton1, typeId, order, urlButton1}
    });
  }
  //
  getEditTitle(id: number, name: string): any {
    return this.dialog.open(EditTitleDialogComponent, {
      data: {id, name}
    });
  }
  //
  // getCreateProductService(typeId: number, order: number, column: number, title: string, productServicesItems: Array<any>): any {
  //   return this.dialog.open(CreateProductServiceDialogComponent, {
  //     data: {typeId, order, column, title, productServicesItems}
  //   });
  // }
  //
  // getEditProductService(position: number, column: number, title: string, productServicesItem: Array<any>): any {
  //   return this.dialog.open(EditProductServiceDialogComponent, {
  //     data: {position, column, title, productServicesItem}
  //   });
  // }
  //
  // getEditNavLink(id: number, value: string, img: string, url: string, urlExterno: number, imgActive: number, headerItems: Array<any>): any {
  //   return this.dialog.open(EditNavlinkComponent, {
  //     data: {id, value, img, url, urlExterno, imgActive, headerItems}
  //   });
  // }
  //
  // getEditBlog(id: number, img: string, img64: string, date: string, author: string, authorImg: string, authorImg64: string, content: string,
  //             title: string, tags: Array<any>): any {
  //   return this.dialog.open(EditBlogComponent, {
  //     data: {author, content, title, tags, img, date, authorImg, id, authorImg64, img64}
  //   });
  // }

  getCreateBlog(id: number, img: string, img64: string, date: string, author: string, authorImg: string, authorImg64: string, content: string,
                title: string, tags: Array<any>): any {
    return this.dialog.open(CreateBlogComponent, {
      data: {author, content, title, tags, img, date, authorImg, id, authorImg64, img64}
    });
  }


}
